var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCreditCardOtherCreditCardName(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_credit_card_other_credit_card_name_svg__clip0_37861_244099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6h24c.5 0 1 .2 1.3.5.4.4.7.9.7 1.5v16c0 1.1-.9 2-2 2H4c-.5 0-1-.2-1.3-.5-.4-.4-.7-.9-.7-1.5V8c0-1.1.9-2 2-2z",
    fill: "#33A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18.5v-1h11v1H4zM4 21.5v-1h7v1H4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 22.5h6c.3 0 .5-.2.5-.5v-5c0-.3-.2-.5-.5-.5h-6c-.3 0-.5.2-.5.5v5c0 .3.2.5.5.5z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424143",
    d: "M2 10h28v4H2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_credit_card_other_credit_card_name_svg__clip0_37861_244099"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgIconCreditCardOtherCreditCardName;